import { FontIcon, getTheme, IStyle, ITheme, mergeStyleSets } from '@fluentui/react';
import React from 'react';
import { xlate, xlationContext } from '../../../../framework/utils/i18n';
import { IPresenterAccountPreferences } from '../../../../entities-generated/common/presenter-account-preferences';
import { toLocalDate } from '../../../../framework/utils/date-time';
import { TimeDisplayFormat } from '../../../../entities-generated/common/time-display-format';
import { browserUses12HourTime } from '../../../../framework/utils/device';
import { formatString } from '../../../../framework/utils';

xlationContext('Live discussion end time display');

interface IPRIVATE_TIME_MONITOR_HEADER_END_TIME_DISPLAYProps {
  accountSettings: IPresenterAccountPreferences;
  endTime: number;
}

const getStyleClasses = (theme: ITheme) => {
  const root: IStyle = {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: 0,
    color: theme.palette.white,
    gap: 5,
    fontWeight: 400,
  };

  const icon: IStyle = {
    margin: 0,
    padding: 0,
    fontWeight: 400,
    fontSize: 22,

    '& span': {
      display: 'block',
      clip: 'rect(1px, 1px, 1px, 1px)',
      width: 1,
      height: 1,
      overflow: 'hidden',
    },
  };

  const time: IStyle = {
    margin: 0,
    padding: 0,
    fontSize: 16,
  };

  return mergeStyleSets({
    root,
    icon,
    time,
  });
}

export const PRIVATE_TIME_MONITOR_HEADER_END_TIME_DISPLAY: React.FunctionComponent<IPRIVATE_TIME_MONITOR_HEADER_END_TIME_DISPLAYProps> = (props) => {
  const theme = getTheme();
  const styles = getStyleClasses(theme);
  const endTime = toLocalDate(props.endTime);
  const twelveHourTimeDisplay = props.accountSettings.timeDisplayFormat !== TimeDisplayFormat.ClientDefault ?
    props.accountSettings.timeDisplayFormat === TimeDisplayFormat.Hour12 : browserUses12HourTime();
  const displayFormat = twelveHourTimeDisplay ? '{endTime:d-hmmaa}' : '{endTime:d-HHmm}'
  const displayText = formatString(displayFormat, { endTime }).formattedString;

  return (
    <div className={styles.root}>
      <h2 className={styles.icon}>
        <FontIcon
          iconName='BufferTimeBoth'
          aria-hidden
        />
        <span>{xlate('Discussion end time')}</span>
      </h2>
      <p className={styles.time}>{displayText}</p>
    </div>
  );
};
